import React from "react";
import garantipartner from "../../assests/images/logo1.jpeg";
import fragus from "../../assests/images/logo.jpeg";
import moneygo from "../../assests/images/logo3.jpeg";
import mymoney from "../../assests/images/logo4.jpeg";
import santander from "../../assests/images/logo5.jpeg";
const partners = [{image:garantipartner,name:"GP"},{image:fragus,name:"Fragus Group"},{image:moneygo,name:"MoneyGo"},{image:mymoney,name:"MyMoney"},{image:santander,name:"Santander Consumer Bank"}];
const InfoCard = () => (
  <section className="tb-partners" aria-labelledby="tb-partners-title">
    <div className="tb-container"><div className="tb-partners-heading"><p className="tb-eyebrow" id="tb-partners-title">VÅRA SAMARBETSPARTNERS</p><p>Prata med oss om vilka alternativ som passar dig.</p></div><ul className="tb-partner-grid">{partners.map(partner=><li key={partner.name}><img src={partner.image} alt={partner.name} loading="lazy" width="180" height="90" /></li>)}</ul></div>
  </section>
);
export default InfoCard;
